import VerticalBarChart from "../../../../../src/core/VerticalBarChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  VerticalBarChart,
  Playground,
  React
};